import { mapModelToRow, Row } from 'app/shared/features/map-row-selector/models/row';
import { CentralPathRowSetModel } from 'app/shared/features/map-row-selector/models/server/central-path-row-set-model';

export const mapModelToCentralPathRowSet = (model: CentralPathRowSetModel): CentralPathRowSet => {
    return {
        left: mapModelToRow(model.left),
        right: mapModelToRow(model.right),
    };
};

export interface CentralPathRowSet {
    left?: Row;
    right?: Row;
}
